(() => {
  const modal = document.querySelector('[data-elevent-contact-modal]');
  if (!modal) return;

  const openTriggers = document.querySelectorAll('[data-elevent-contact-open]');
  const closeTriggers = document.querySelectorAll('[data-elevent-contact-close]');

  const openModal = () => {
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    }
  };

  const closeModal = () => {
    if (modal.open) {
      modal.close();
    }
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  modal.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });

  if (window.location.hash === '#contact-form' || window.location.search.includes('contact_posted=true')) {
    openModal();
  }
})();
